import { DateTime } from 'luxon'
import { connect } from 'react-redux'
import { AnyAction, Dispatch } from 'redux'
import LogText, { LogTextObject } from '../../../components/molecules/logText'
import TableComponent from '../../../components/molecules/table'
import { StoreState } from '../../../state/configureStore'
import { translateColorCode } from '../../../utils/text'
import LogLevelDisplay from '../../../components/molecules/logs/logLevelDisplay'
import { toReadableTime } from '../../../functions'
import Text from '../../../components/atoms/text/text'
import { LogItem } from './logSection'

const columnNames = [
  {
    displayName: 'Level',
    serverName: null//'level'
  },
  {
    displayName: 'Timestamp',
    serverName: 'timestamp'
  },
  {
    displayName: 'Log',
    serverName: null //'record'
  },
  {
    displayName: 'Source',
    serverName: null //'source'
  }
]

function extractTimestamp(text: string): DateTime | null {
  const now = DateTime.now()
  let firstSection = text?.split(']')[0]
  if (!firstSection) return null
  firstSection = firstSection.replace('[', '')
  let dateTime = DateTime.fromFormat(firstSection, 'EEE MMMM  d TT yyyy')
  if (!dateTime || !dateTime.isValid) {
    dateTime = DateTime.fromFormat(firstSection, 'EEE MM  d TT yyyy')
    if (!dateTime || !dateTime.isValid) return null
  }

  return dateTime
}

function processLogText(text = ''): LogTextObject[] {
  // eslint-disable-next-line
  const regexColorCode = /\x1B\[\d+m/g;

  const colorsIterator = text.matchAll(regexColorCode)
  let textStyles: Object[] = []
  let textPieces = text.split(regexColorCode)

  let nextColor = colorsIterator.next()
  while (nextColor?.value && nextColor?.value[0]) {
    const colorCode = nextColor.value[0].replace('\x1B[', '')

    textStyles.push(translateColorCode(colorCode))
    nextColor = colorsIterator.next()
  }

  if (!textStyles?.length || textStyles.length === 0) {
    return [{
      text: text,
      style: undefined
    }]
  }

  // if we have as many colour codes as split texts -> all of them have their own colour code
  // if we have one less -> first one does not have a colour code -> should render black
  if (textStyles?.length === textPieces?.length - 1) {
    textStyles = [translateColorCode('')].concat(textStyles)
  }
  else if (textStyles?.length !== textPieces?.length) {
    console.error("Something went wrong trying to parse log text:", text)
    return [{
      text: text,
      style: undefined
    }]
  }

  let toReturn: LogTextObject[] = []
  textPieces?.forEach((piece, index) => {
    toReturn.push({
      text: piece,
      style: textStyles[index]
    })
  })

  return toReturn
}

export type SortOn = 'timestamp'  | 'level' | 'record' | 'source'

const LogTable = ({
  logs,
  total,
  dimensions,
  countPerPage,
  page,
  sortingOn,
  descending,
  setCountPerPage,
  setPage,
  setDescending,
  setSortingOn
}:{
  logs: LogItem[],
  total: number,
  dimensions:any,
  countPerPage: number,
  page: number,
  sortingOn: SortOn
  descending: boolean,
  setCountPerPage: (newCount: number) => void,
  setPage: (newPage: number) => void,
  setSortingOn?: ((newSortingOn: any) => any) | null,
  setDescending?: (newDescending: boolean) => any,
}) => {
  const now = DateTime.now()
  const isMobile = dimensions.device === 'mobile'

  return (
          <TableComponent
          animateTable
          countPerPage={countPerPage}
          page={page}
          descending={descending}
          sortingOn={sortingOn}
          setCountPerPage={setCountPerPage}
          setPage={setPage}
          setDescending={setDescending}
          setSortingOn={setSortingOn}
          noHover={true}
          columnNames={isMobile ? columnNames.map(col => {
            if (col.displayName === "Timestamp") col.displayName = "Time"
            return col
          }) : columnNames}
          rows={logs.map((log, index) => {
            const dateTime = DateTime.fromISO(log.timestamp) ?? extractTimestamp(log.record)
            const timestampStr = toReadableTime(dateTime, now)
            return {
              'id': index,
              'Level': <LogLevelDisplay vertical={isMobile} level={log.level}/>,
              'Timestamp': isMobile ? <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Text style={{ fontSize: 14 }} key={index}>
                  {toReadableTime(dateTime, now, false, true)}
                </Text>
                <Text style={{ fontSize: 14 }} key={index}>
                  {dateTime.toFormat('HH:mm')}
                </Text>
              </div> : timestampStr,
              'Log': <LogText textPieces={processLogText(log.record)} />,
              'Source': log.source
            }
          })}
          total={total} />
    
  )
}
const mapStateToProps = (state: StoreState) => ({
  dimensions: state.dimensions
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(LogTable)